// extracted by mini-css-extract-plugin
module.exports = {"aside":"NavBar_aside__2OnzA","nav":"NavBar_nav__2-d9C","link":"NavBar_link__nMljQ","active":"NavBar_active__1cBgl"};